import { renderCardForm } from './forms/cardForm.js';
class Boxpay {
    static async authenticate(apiKey) {
        if (!apiKey) {
            throw new Error("API key is required to authenticate.");
        }

        const dataSheet = [
            {
                merchantKey: '1234',
                enabledPaymentOptions: ['card', 'upi']
            },
            {
                merchantKey: '4567',
                enabledPaymentOptions: ['card', 'emi']
            }
        ];

        const merchant = dataSheet.find(d => d.merchantKey === apiKey);
        if (!merchant) throw new Error('Authentication failed');
        try {
            // Simulate an API request to authenticate
            // const response = await fetch('https://api.boxpay.com/authenticate', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'Authorization': `Bearer ${apiKey}`,
            //     },
            // });

            // if (!response.ok) {
            //     throw new Error('Authentication failed');
            // }

            // const data = await response.json();

            const data = {
                enabledPaymentOptions: merchant.enabledPaymentOptions
            }

            // Return a function that provides payment options
            return new BoxpayPaymentOptions(data);
        } catch (error) {
            console.error("Error during authentication:", error);
        }
    }
}

class BoxpayPaymentOptions {
    constructor(data) {
        this.data = data;
    }

    // Method to check if the user has access to any of the provided payment options
    hasAccessToPaymentOptions(type) {
        return type.some(option => this.data.enabledPaymentOptions.includes(option));
    }



    // Method to render payment options based on provided keys
    render({ type }) {
        if (!this.hasAccessToPaymentOptions(type)) {
            throw new Error(`You don't have access to ${type} payment option`);
        }
        if (type.includes('card')) {
            return renderCardForm();
        }
        const container = document.createElement('div');
        container.innerText = `Payment options enabled: ${type.join(', ')}`;
        return container;
    }
}

// Example of exposing SDK globally for browser use via CDN
if (typeof window !== 'undefined') {
    window.Boxpay = Boxpay;
}

export default Boxpay;
